<!--
 * @Author: vinc
 * @LastEditTime: 2020-11-18 16:59:09
 -->
<template>
  <div class="mall_public_h" :class="{ 'hide-shadow': hideShadow }">
    <div class="mall_h_tit">
      <div class="left">
        <img src="@/assets/images/logo.png" /><span>齐心福利</span>
      </div>
      <div class="right">
        <ul>
          <li
            v-for="(item, index) in navList"
            :class="{ active: $route.path == item.path }"
            :key="index"
            @click.stop="changeNav(item)"
          >
            {{ item.title }}
            <span v-show="$route.path == item.path"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="cover"></div>
  </div>
</template>
<script>
export default {
  props: ["shopTitle", "footprint", "cartEdit", "hideShadow", "searchShow"],
  data() {
    return {
      editBtn: false,
      navList: [
        {
          title: "首页",
          path: "/",
        },
        {
          title: "福利商城",
          path: "",
          link: 1,
        },
        {
          title: "员工福利",
          path: "/mall",
        },
        {
          title: "关于齐心",
          path: "",
        },
        {
          title: "联系我们",
          path: "",
        },
      ],
    };
  },
  methods: {
    changeNav(item) {
      if (item.link) {
        return window.open(this.$pathUrls.shop_pc);
      }
      if (item.path) {
        this.$store.dispatch("changeRouter", { path: item.path, query: {} });
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1200px) {
  .mall_h_tit {
    .right {
      ul {
        li {
          margin-left: 30px !important;
          font-size: 20px !important;
        }
      }
    }
  }
}
.mall_public_h {
  &.hide-shadow {
    .mall_h_tit {
      box-shadow: none;
    }
  }
  .mall_h_tit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    height: 92px;
    box-shadow: 0px 5px 10px 0px rgba(158, 158, 158, 0.15);
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 999;
    background: #fff;
    padding: 0 80px;
    .left {
      display: flex;
      align-items: center;
      cursor: pointer;
      min-width: 300px;
      span {
        font-size: 30px;
        font-weight: bold;
        padding-left: 20px;
      }
    }
    .right {
      height: 100%;
      font-size: 24px;
      ul {
        display: flex;
        align-items: center;
        height: 100%;
        li {
          margin-left: 75px;
          height: 100%;
          transition: all 0.3s;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          &.active {
            color: #e60011;
          }
          span {
            width: 100%;
            height: 7px;
            position: absolute;
            background: #e60011;
            bottom: 0;
            left: 0;
          }
        }
      }
    }
  }
  .cover {
    width: 100%;
    height: 92px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue